<template>
  <div class="allContent">

    <div class="header" style="margin-top: 0px;">
    	<div class="header_content1">
    		<div class="header_content_img">



          <div style="float:left;width:280px;height:140px;" v-if="unitCode=='410825000000'">
            <img src="../../assets/images/wenxianLogo.jpg"  style="width: 100%;height:100%" />
          </div>
          <div style="float:left;width:150px;height:150px;" v-if="unitCode.substring(0,4)=='4115'">
            <img src="../../assets/images/logo_xinyang.jpg"  style="width: 100%;height:100%" />
          </div>

          <div style="width:450px;height:70px;float:left;margin-top: 20px;" v-if="unitCode=='410800000000'">
    			<img src="../../assets/images/top_titlejz.png"  style="width: 100%;height:100%"/>
          </div>

          <div style="width:320px;height:160px;float:left;margin-top: 0px;" v-if="unitCode=='410225000000'">
            <img src="../../assets/images/top_title_lankao.jpg"  style="width: 100%;height:100%"/>
          </div>


          <div style="width:450px;;height:70px;float:left;margin-top: 50px;" v-if="unitCode=='411000000000'">
          <img src="../../assets/images/top_title_xuchang.png"  style="width: 100%;height:100%"/>
          </div>


          <div style="float: left;margin-left:-60px; width: 400px; height: 100px; font-size: 30px; color: rgb(0, 153, 70); padding-top: 60px;" v-if="unitCode=='410200000000'">
             <strong>开封市农村产权交易中心官网</strong>
          </div>

          <div style="float:left;width:700px;margin-left:10px;height:100px;font-size:28px;color:#009946;padding-top: 35px;">
            <strong>{{title}}</strong>

            <div style="float: left;margin-left:0px;margin-top: 20px;font-size: 28px;padding-top: 10px;cursor: pointer;">
              <a href="http://xinyang.property.zwdit.com/" target="_blank" style="color: #009946;">
                <strong>信阳市农村集体“三资”监管预警平台</strong>
              </a>
            </div>
          </div>

          
        

          



    		</div>
    	</div>
    </div>
    <div style="width: 100%;height: 61px;background-color:#4cb050;">
      <indexMenu
        style="width: 1220px;background-color:#4cb050;margin: 0 auto;height: auto;overflow: hidden;border: none;">
      </indexMenu>
    </div>


   <router-view v-if="isRouterAlive"/>

  
<indexFooter></indexFooter>

  </div>



</template>

<script>
  import indexMenu from '@/components/menus/indexMenu.vue'
  import indexFooter from '@/components/footer/indexFooter.vue'
  export default {
    provide () {
      return {
        reload: this.reload
      }
    },
    data() {
      return {
        unitCode: localStorage.getItem("unitCode"),
        title:"",
        isRouterAlive: true

      }
    },
    mounted() {
    document.title = localStorage.getItem("unitName")+"产权交易平台官网";
    if(this.unitCode.substring(0,4)=="4115"){
      this.title=localStorage.getItem("unitName")+"产权交易平台官网";
    }

    },
    methods: {
 reload () {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    }
    },

    components: {
      indexMenu,
      indexFooter
    },
  };
</script>

<style scoped="">
  @import url("../../assets/css/index.css");
  @import url("../../assets/css/base.css");
  @import url("../../assets/css/main.css");
  @import url("../../assets/css/news.css");

  .allContent{
    width: 100%;height:auto;overflow: hidden;background-color: #e4eff6; background-image: url(../../assets/bg.jpg);
      background-size: cover
  }


 .header_content1{
  	width: 100%;height:180px;
   /* background-image: url(../../assets/top_bg.jpg);*/
    background-size: cover
  }
  .header_content_img{
  	height: 150px;padding-left: 10px;width: 80%;margin-top: 5px;padding-top: 0px;
  }
  .news {
    float: left;
    width: 110px;
    text-align: center;
    height: 40px;
    cursor: pointer;
    line-height: 40px;
  }
  body{min-width:1200px; background:#d6e8f4;}
.newsHeader{
  height:320px;border: 1px solid #efefef;margin-left: 15px;
}
  .activeSelect {
    background-color: #4cb050;
    color: white;
  }

  .hone-container {
    height: 100%;
  }

  a-layout-content {
    height: 100%;
  }

  .ant-layout-header {
    /* 2850A0 */
    padding: 0px;
    background-color: #3c8dbc !important;
  }

  .main {
    width: 1220px;
    margin: 0 auto;
    height: auto;
    overflow: hidden;
    background-color: white;
    margin-top: 5px;
  }
</style>
